"use client";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useEffect, useState } from "react";
import ReceivingSettings from "../../components/pages-components/checkout/checkout-helpers/receiving-settings/ReceivingSettings";
import { useAtom } from "jotai";
import { isSignedInAtom } from "@/hooks/authAtoms";
import DeliveryNavpar from "./helpers/DeliveryNavpar/DeliveryNavpar";
import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { receivingSettingsAtom } from "@/hooks/receivingHeaderAtom";
import { getSettingsFromStorage } from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/helpers";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import {
  getBranchIdCookie,
  storeBranchIdCookie,
} from "@/utils/functions/cookieOperations";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { usePathname } from "next/navigation";

interface props {
  mobileTop: number;
}
const DeliveryHeader: React.FC<props> = ({ mobileTop }) => {
  const pathname = usePathname();
  const getCompany = useGetCompanyQuery();
  const [receivingSetting] = useAtom(receivingSettingsAtom);
  const settingsFromLocalStorage = getSettingsFromStorage(receivingSetting!);
  const { show_receiving_header } = getCompany?.data?.result ?? {};
  const getProfile = useGetProfileQuery();
  const profile = getProfile?.data?.result;
  const { settings } = profile ?? {};
  const [isSignedIn] = useAtom(isSignedInAtom);
  const mobile = useIsMobile();
  const top = !mobile ? 64 : mobileTop;
  const hasReceivingType = isSignedIn
    ? !!settings?.receiving_type
    : !!receivingSetting?.receiving_type;

  // Check if current page is an auth page or not found page
  const authPages = [
    PagesPaths.signin,
    PagesPaths.register,
    PagesPaths.confirmation,
    PagesPaths.forget_password,
    PagesPaths.reset_password,
    PagesPaths.register_confirm,
    PagesPaths.password_confirm,
    PagesPaths.otp_signin,
    PagesPaths.notFound,
  ];
  const isAuthOrNotFoundPage = authPages.includes(pathname as PagesPaths);

  const [isDrawerOpen, setIsDrawerOpen] = useState(
    !hasReceivingType && !isAuthOrNotFoundPage,
  );

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    if (!isSignedIn || !settings) return;
    const { receiving_type, delivery_branch, pickup_branch } = settings ?? {};
    const BranchIdCookie = getBranchIdCookie();
    const receivingBranchId =
      receiving_type === DeliveryMethodsTypes.delivery
        ? delivery_branch
        : pickup_branch;
    receivingBranchId &&
      receivingBranchId !== +BranchIdCookie &&
      storeBranchIdCookie(receivingBranchId!);
  }, [settings]);

  useEffect(() => {
    // Close drawer if on auth/not found pages, otherwise show it if no receiving type is set
    if (isAuthOrNotFoundPage) {
      setIsDrawerOpen(false);
    } else {
      setIsDrawerOpen(!hasReceivingType);
    }
  }, [hasReceivingType, isAuthOrNotFoundPage]);

  if (!show_receiving_header) return;
  return (
    <>
      <div style={{ height: top }} />
      <DeliveryNavpar
        top={top}
        handleDrawerOpen={handleDrawerOpen}
        mobile={mobile}
        settings={isSignedIn ? settings! : settingsFromLocalStorage}
      />
      {isDrawerOpen && (
        <ReceivingSettings
          isOpen={isDrawerOpen}
          onClose={
            isAuthOrNotFoundPage || hasReceivingType
              ? handleDrawerClose
              : undefined
          }
        />
      )}
    </>
  );
};
export default DeliveryHeader;
